module.exports = require('fela/lib/plugins/fallbackValue')



//////////////////
// WEBPACK FOOTER
// ../~/fela-plugin-fallback-value/index.js
// module id = 457
// module chunks = 0